import React from "react";
import { apiPost } from "api/callApi";
import { formatFileSize } from "utils/helper";
import SC from "./style";
import TooltipText from "components/TooltipText";

const FileCard = ({ data = { files: [] } }) => {
  const getUrl = async (fileKey) => {
    try {
      const response = await apiPost("/v1/journal/download", {
        filekey: fileKey,
      });
      return response.fileUrl;
    } catch (error) {
      console.error("Error fetching file URL:", error);
      return null;
    }
  };

  const handleDownload = async (fileKey, fileName) => {
    try {
      const url = await getUrl(fileKey);
      if (!url) return;

      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName || "downloaded-file";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <>
      {data.files.map((file, index) => (
        <SC.Container
          key={index}
          onClick={() => handleDownload(file.fileUrl, file.fileName)}
        >
          <SC.FileNameContainer>
            <SC.FileName>
              {" "}
              <TooltipText
                title={file.fileName || "Unknown File"}
                maxLength={25}
              />
            </SC.FileName>
            <SC.FileSize>{formatFileSize(file.fileSize)}</SC.FileSize>
          </SC.FileNameContainer>
          <SC.DownloadIcon />
        </SC.Container>
      ))}
    </>
  );
};

export default FileCard;
